import { sendAction } from '../../core/action.js';
import WinStoreCallbackObserver, { WinStoreCallbacks } from './WinStoreCallbackObserver.js';

function getUserCountry() {
    return new Promise((resolve) => {
        WinStoreCallbackObserver.once(WinStoreCallbacks.OnUserCountryReceived, (country) => {
            resolve(country);
        });
        sendAction({
            actionId: 'getUserCountry',
        });
    });
}

export { getUserCountry };
//# sourceMappingURL=getUserCountry.js.map
